import { gql } from '@apollo/client';

export const QUERY_ONBOARDING_STEP1 = gql`
  query onBoardingStep1 {
    step1 {
      data {
        attributes {
          content {
            title
            description
            image {
              data {
                attributes {
                  url
                  alternativeText
                }
              }
            }
            button {
              text
              link
            }
          }
        }
      }
    }
  }
`;
